module.exports = __webpack_public_path__ + "img/imginspo1.f3a1d75d.png";